import { Routes } from '@angular/router';

import { MainComponent } from './main.component';

export const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'category/:slug',
        loadChildren: () => import('../category/category.routes').then(m => m.routes)
      },
    ]
  }
]
